'use strict';
angular.module('cvsApp').service('getCampaignInfoService', ['networkService', 'getCampaignInfoModel', 'configservice', 'PageValues', function (NS, GCIM, config, PageValues) {

    function getCampaignInfoService() {
        this.getCampaignInfo = function (callBackSuccess, messageID) {
            var appConfig = config.appConfig();
            PageValues.appConfig = appConfig;

            var url = PageValues.appConfig.depServicesConfig.serviceURL + '/DEPAGPv1/securechat/1.0.0/getSplCampaignInfo';

            if (url === "URL_ERROR") {

            } else {
                var request = {
                    url: url,
                    header: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json'
                    },
                    data: requestBody(messageID),
                    onSuccess: callBackSuccess
                }
                cvsUtility.commonServiceCode(url, "getCampaignInfo", GCIM, request, callBackSuccess, NS);
            }

        }

        var requestBody = function (messageID) {
            var apikey = PageValues.appConfig.depServicesConfig.apiKey;
            var deviceType = "desktop";
            var xid =cvsUtility.queryMap.xid 
            if (cvsUtility.queryMap.mobileAppStyle != undefined && (cvsUtility.queryMap.mobileAppStyle == true || cvsUtility.queryMap.mobileAppStyle == "true")) {
                deviceType = "mobileApp";
            }
            else if (cvsUtility.isMobile()) {
                deviceType = "mobile";
            }
            var reqObj = {
                "requestMetaData": {
                    "lineOfBusiness": "Specialty",
                    "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                    "apiKey": apikey,
                    "channelName": cvsUtility.queryMap.channel,
                    "deviceToken": "d9708df38d23192e",
                    "deviceType": deviceType,
                    "responseFormat": "JSON",
                    "securityType": "apiKey",
                    "source": "Specialty",
                    "type": "node"
                },
                "requestPayloadData": {
                    "tokenID": "",
                    "messageID": messageID,
                    "xID": xid
                }
            };
            return reqObj;
        }
    }

    return new getCampaignInfoService();
}]);